import React, { useState, useEffect } from 'react';
import http from './utils/http';
import axios from 'axios';
import { useSnackbar } from 'react-simple-snackbar';
import { FormattedMessage } from 'react-intl';
//the function to call the push server: https://github.com/Spyna/push-notification-demo/blob/master/front-end-react/src/utils/http.js

import { isPushNotificationSupported, askUserPermission, registerServiceWorker, createNotificationSubscription, deleteNotificationSubscription, getUserSubscription } from './SubscriptionManager';
//import all the function created to manage the push notifications

const pushNotificationSupported = isPushNotificationSupported();
//first thing to do: check if the push notifications are supported by the browser

export default function usePushNotifications(props) {
	//const [userConsent, setSuserConsent] = useState(typeof navigator !== 'undefined' && Notification.permission);
	//to manage the user consent: Notification.permission is a JavaScript native function that return the current state of the permission
	//We initialize the userConsent with that value
	const [userSubscription, setUserSubscription] = useState(null);
	//to manage the use push notification subscription
	const [pushServerSubscriptionId, setPushServerSubscriptionId] = useState();
	//to manage the push server subscription
	const [error, setError] = useState(null);
	//to manage errors
	const [loading, setLoading] = useState(true);
	//to manage async actions
	const [userInfo, setUserInfo] = useState([]);

	const [mode, setMode] = useState('#11362a');

	const [color, setColor] = useState('#e7e8eb');

	useEffect(() => {
		const darkMode = typeof document !== 'undefined' && document.body.classList.contains('dark-mode');
		if (darkMode) {
			setMode('#f8e71b');
			setColor('#27292D');
		}
	});

	const options = {
		position: 'bottom-right',
		style: {
			backgroundColor: mode,
			color: color,
			fontFamily: props.currLanguage === 'ar-QA' ? 'DIN Next LT W23,Roboto,sans-serif' : 'DIN Next LT W01 Regular,Roboto,sans-serif',
			textAlign: props.currLanguage === 'ar-QA' ? 'right' : 'left'
		},
		closeStyle: {
			color: color
		}
	};

	const [openSnackbar] = useSnackbar(options);

	useEffect(() => {
		if (pushNotificationSupported) {
			setLoading(true);
			setError(false);
			registerServiceWorker().then(() => {
				setLoading(false);
			});
		}
	}, []);

	useEffect(() => {
		setLoading(true);
		setError(false);
		if (pushNotificationSupported) {
			const getExixtingSubscription = async () => {
				const existingSubscription = await getUserSubscription();
				setUserSubscription(existingSubscription);
				setLoading(false);
			};
			getExixtingSubscription();
		}
	}, []);
	//Retrieve if there is any push notification subscription for the registered service worker
	// this use effect runs only in the first render

	useEffect(() => {
		const url = 'https://www.cloudflare.com/cdn-cgi/trace';
		axios
			.get(url)
			.then(async response => {
				let obj = {};
				for (let entry of response.data.split('\n')) {
					let pair = entry.split('=');
					obj[pair[0]] = pair[1];
				}
				// @ts-ignore
				setUserInfo({ ip: obj.ip, user_agent: obj.uag, city: obj.colo, country: obj.loc });
			})
			.catch(error => console.log(error));
	}, []);

	/**
	 * define a click handler that asks the user permission,
	 * it uses the setSuserConsent state, to set the consent of the user
	 * If the user denies the consent, an error is created with the setError hook
	 */
	const onClickAskUserPermission = () => {
		setLoading(true);
		setError(false);
		askUserPermission().then(consent => {
			// setSuserConsent(consent);
			if (consent !== 'granted') {
				setError({
					name: 'Consent denied',
					message: 'You denied the consent to receive notifications',
					code: 0
				});
			}
			setLoading(false);
		});
	};
	//

	/**
	 * define a click handler that creates a push notification subscription.
	 * Once the subscription is created, it uses the setUserSubscription hook
	 */
	const onClickSusbribeToPushNotification = () => {
		setLoading(true);
		setError(false);
		createNotificationSubscription()
			.then(function(subscription) {
				document.getElementById('fab').classList.add('dismiss');
				onClickSendSubscriptionToPushServer(subscription);
				setTimeout(function() {
					openSnackbar(<FormattedMessage id={'push_success'} />);
				}, 500);
				setLoading(false);
				onClickSendNotification(subscription, 'welcome');
				setUserSubscription(subscription);
			})
			.catch(err => {
				console.error("Couldn't create the notification subscription", err, 'name:', err.name, 'message:', err.message, 'code:', err.code);
				setError(err);
				setTimeout(function() {
					openSnackbar(<FormattedMessage id={'push_generic_error'} />);
				}, 500);
				setLoading(false);
			});
	};

	/**
	 * define a click handler that sends the push susbcribtion to the push server.
	 * Once the subscription ics created on the server, it saves the id using the hook setPushServerSubscriptionId
	 */
	const onClickSendSubscriptionToPushServer = subscription => {
		setLoading(true);
		setError(false);
		const payload = {
			endpoint: JSON.stringify(subscription),
			userInfo: JSON.stringify(userInfo)
		};
		http.post('/.netlify/functions/add-subscription', payload)
			.then(function(response) {
				setPushServerSubscriptionId(response.id);
				setLoading(false);
			})
			.catch(err => {
				setLoading(false);
				setError(err);
			});
	};

	/**
	 * define a click handler that request the push server to send a notification, passing the id of the saved subscription
	 */
	const onClickSendNotification = async (subscription, templateType) => {
		setLoading(true);
		setError(false);
		let payload = {};
		if (templateType === 'welcome') {
			payload = { endpoint: JSON.stringify(subscription), templateType: 'welcome' };
			http.post('/.netlify/functions/send-notification', payload).catch(err => {
				setError(err);
			});
			setLoading(false);
		}
	};

	const onClickUnsubscribeFromPushServer = () => {
		setLoading(true);
		setError(false);
		deleteNotificationSubscription()
			.then(function(subscription) {
				// @ts-ignore
				onClickRemoveSubscriptionFromPushServer(subscription);
			})
			.then(function() {
				setUserSubscription(null);
				setLoading(false);
			})
			.catch(err => {
				console.error("Couldn't create the notification subscription", err, 'name:', err.name, 'message:', err.message, 'code:', err.code);
				setError(err);
				setLoading(false);
			});
	};

	const onClickRemoveSubscriptionFromPushServer = () => {
		setLoading(true);
		setError(false);
		const payload = {
			endpoint: JSON.stringify(userSubscription),
			userInfo: JSON.stringify(null)
		};
		http.post('/.netlify/functions/delete-subscription', payload)
			.then(function() {
				setPushServerSubscriptionId(null);
				openSnackbar(<FormattedMessage id={'push_disabled'} />);
				setLoading(false);
			})
			.catch(err => {
				openSnackbar(<FormattedMessage id={'push_disable_error'} />);
				setLoading(false);
				setError(err);
			});
	};

	/**
	 * returns all the stuff needed by a Component
	 */
	return {
		onClickAskUserPermission,
		onClickSusbribeToPushNotification,
		onClickUnsubscribeFromPushServer,
		pushServerSubscriptionId,
		isPushNotificationSupported,
		onClickSendNotification,
		pushNotificationSupported,
		userSubscription,
		error,
		loading
	};
}
